import React, { ReactNode, useEffect, useState } from "react";
import { AuthProvider, useAuth } from "react-oidc-context";
import { getOIDCConfig } from "./authConfig";
import { CircularProgress, Box } from "@mui/material";
import { getConfig } from "../services/api";

interface AuthenticationProviderProps {
  children: ReactNode;
}

export const AuthenticationProvider: React.FC<AuthenticationProviderProps> = ({
  children,
}) => {
  const [config, setConfig] = useState({} as {authority: string; clientId: string});

  const fetchConfig = async () => {
    const response = await getConfig();
    setConfig(response);
  };

  useEffect(() => {
    fetchConfig();
  }, []);
  return (
    <>
      { config.authority &&
        <AuthProvider {...getOIDCConfig(config.authority, config.clientId)}>
          <AuthenticationGuard>{children}</AuthenticationGuard>
        </AuthProvider>
      }
    </>
  );
};

const AuthenticationGuard: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const { isLoading, isAuthenticated, signinRedirect, error } =
    useAuth();

  React.useEffect(() => {
    // Try silent authentication if not authenticated and not already loading
    if (!isLoading && !isAuthenticated && !error) {
      signinRedirect().catch((err) => {
        console.error("Silent sign-in failed:", err);
        // You may want to redirect to a login page or show a login button here
      });
    }
  }, [isLoading, isAuthenticated, signinRedirect, error]);

  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return <>{children}</>;
};
